import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ControlFailureSectionProp } from ".";
import { DATE_UTIL } from "../../../../../utils/dateUtils";



const OperationalViewSection = (props: ControlFailureSectionProp) => {

    const { t } = useTranslation();
    const { data } = props;

    return (
        <div className="section-wrapper">

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbShortNameEvent")}
                    >
                        <span>{data.short_name_for_event}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbTypeOfEvent")}
                    >
                        <span>{data.type_of_event?.name}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={12}>
                    <Form.Item
                        label={t("ControlFailure.lbOccurrenceDate")}
                    >
                        <span>{DATE_UTIL.convertServerToViewFormat(data.occurrence_date)}</span>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={t("ControlFailure.lbRecognitionDate")}
                    >
                        <span>{DATE_UTIL.convertServerToViewFormat(data.recognition_date)}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={12}>
                    <Form.Item
                        label={t("ControlFailure.lbBaselIILevel1Category")}
                    >
                        <span>{data.category?.name}</span>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={t("ControlFailure.lbBaselIILevel2Category")}
                    >
                        <span>{data.category_level_2?.name}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbLevel2Detail")}
                    >
                        <span>{data.category_level_3?.name}</span>
                    </Form.Item>
                </Col>

            </Row>


            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbDescriptionOfEvent")}
                    >
                        <span>{data.description}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbFailedControlArea")}
                    >
                        <span>{data.failed_control_area?.name}</span>
                    </Form.Item>
                </Col>

            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbDescriptionofFailedControl")}
                    >
                        <span>{data.failed_control_description}</span>
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default OperationalViewSection;